import { useQuery } from '@tanstack/react-query'

import { getFreeeConnectionSettingsForAccounting } from '@src/api'
import { DefaultApiGetFreeeConnectionSettingsForAccountingRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeConnectionSettingsForAccounting = (
  params: DefaultApiGetFreeeConnectionSettingsForAccountingRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () =>
      getFreeeConnectionSettingsForAccounting(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_FREEE_CONNECTION_SETTINGS_FOR_ACCOUNTING,
    ],
  })
}
